import { z } from 'zod';
import {
  AI_MODEL_NAME_PRISMA_TO_WIRE,
  type AiModelNamePrismaKey,
} from './ai-model-name-prisma-to-wire';

type AiModelNameWireValue =
  (typeof AI_MODEL_NAME_PRISMA_TO_WIRE)[AiModelNamePrismaKey];

export const AI_MODEL_NAME_WIRE_VALUES = Object.values(
  AI_MODEL_NAME_PRISMA_TO_WIRE,
) as [AiModelNameWireValue, ...AiModelNameWireValue[]];

export const AiModelNameWireSchema = z.enum(AI_MODEL_NAME_WIRE_VALUES);

export type AiModelNameWire = z.infer<typeof AiModelNameWireSchema>;

export const isAiModelNameWire = (
  value: unknown,
): value is AiModelNameWire => AiModelNameWireSchema.safeParse(value).success;

export const MODEL_NAMES = AI_MODEL_NAME_PRISMA_TO_WIRE;

const AI_MODEL_NAME_WIRE_TO_PRISMA_KEY = Object.fromEntries(
  (
    Object.entries(AI_MODEL_NAME_PRISMA_TO_WIRE) as [
      AiModelNamePrismaKey,
      AiModelNameWire,
    ][]
  ).map(([key, wire]) => [wire, key]),
) as Record<AiModelNameWire, AiModelNamePrismaKey>;

export const aiModelNameWireToPrismaKey = ({
  modelName,
}: {
  modelName: AiModelNameWire;
}): AiModelNamePrismaKey => AI_MODEL_NAME_WIRE_TO_PRISMA_KEY[modelName];

export const aiModelNamePrismaKeyToWire = ({
  modelName,
}: {
  modelName: string;
}): AiModelNameWire => {
  const wire =
    AI_MODEL_NAME_PRISMA_TO_WIRE[modelName as AiModelNamePrismaKey];

  return AiModelNameWireSchema.parse(wire);
};
